var items = {
  "block.minecraft.air": "vista",
  "block.minecraft.stone": "ondo",
  "block.minecraft.granite": "erdëondo",
  "block.minecraft.polished_granite": "runda erdëondo",
  "block.minecraft.diorite": "pelondo",
  "block.minecraft.polished_diorite": "runda pelondo",
  "block.minecraft.andesite": "andëondo",
  "block.minecraft.polished_andesite": "rund' andëondo",
  "block.minecraft.grass_block": "ronwa salquëo",
  "block.minecraft.dirt": "cemen",
  "block.minecraft.coarse_dirt": "torna cemen",
  "block.minecraft.podzol": "pencemen",
  "block.minecraft.crimson_nylium": "carnë niliun",
  "block.minecraft.warped_nylium": "hwinda niliun",
  "block.minecraft.cobblestone": "racondo",
  "block.minecraft.oak_planks": "panor norno",
  "block.minecraft.spruce_planks": "panor súcëo",
  "block.minecraft.birch_planks": "panor hwindëo",
  "block.minecraft.jungle_planks": "panor toa rostaurëo",
  "block.minecraft.acacia_planks": "panor nísimaldo",
  "block.minecraft.dark_oak_planks": "panor morinorno",
  "block.minecraft.crimson_planks": "carnitoinë panor",
  "block.minecraft.warped_planks": "hwindë panor",
  "block.minecraft.oak_sapling": "nessornë norno",
  "block.minecraft.spruce_sapling": "nessornë súcëo",
  "block.minecraft.birch_sapling": "nessornë hwindëo",
  "block.minecraft.jungle_sapling": "nessornë rostaurëo",
  "block.minecraft.acacia_sapling": "nessornë nísimaldo",
  "block.minecraft.dark_oak_sapling": "nessornë morinorno",
  "block.minecraft.bedrock": "sundondo",
  "block.minecraft.sand": "litsë",
  "block.minecraft.red_sand": "carnë litsë",
  "block.minecraft.gravel": "virittë",
  "block.minecraft.gold_ore": "sincë malto",
  "block.minecraft.iron_ore": "sincë ango",
  "block.minecraft.coal_ore": "sincë hyulmo",
  "block.minecraft.nether_gold_ore": "sincë malto nethero",
  "block.minecraft.oak_log": "runda norno",
  "block.minecraft.spruce_log": "runda súcëo",
  "block.minecraft.birch_log": "runda hwindëo",
  "block.minecraft.jungle_log": "runda rostaurëo",
  "block.minecraft.acacia_log": "runda nísimaldo",
  "block.minecraft.dark_oak_log": "runda morinorno",
  "block.minecraft.crimson_stem": "carnë telco",
  "block.minecraft.warped_stem": "hwinda telco",
  "block.minecraft.stripped_oak_log": "heltina runda norno",
  "block.minecraft.stripped_spruce_log": "heltina runda súcëo",
  "block.minecraft.stripped_birch_log": "heltina runda hwindëo",
  "block.minecraft.stripped_jungle_log": "heltina runda rostaurëo",
  "block.minecraft.stripped_acacia_log": "heltina runda nísimaldo",
  "block.minecraft.stripped_dark_oak_log": "heltina runda morinorno",
  "block.minecraft.stripped_crimson_stem": "heltina carnë telco",
  "block.minecraft.stripped_warped_stem": "heltina hwinda telco",
  "block.minecraft.stripped_oak_wood": "heltina toa norno",
  "block.minecraft.stripped_spruce_wood": "heltina toa súcëo",
  "block.minecraft.stripped_birch_wood": "heltina toa hwindëo",
  "block.minecraft.stripped_jungle_wood": "heltina toa rostaurëo",
  "block.minecraft.stripped_acacia_wood": "heltina toa nísimaldava",
  "block.minecraft.stripped_dark_oak_wood": "heltina toa morinorno",
  "block.minecraft.stripped_crimson_hyphae": "teccor avahaira aira",
  "block.minecraft.stripped_warped_hyphae": "teccor avahaira hwarin",
  "block.minecraft.oak_wood": "toa norno",
  "block.minecraft.spruce_wood": "toa súcëo",
  "block.minecraft.birch_wood": "toa hwindëo",
  "block.minecraft.jungle_wood": "toa rostaurëo",
  "block.minecraft.acacia_wood": "toa nísimaldo",
  "block.minecraft.dark_oak_wood": "toa morinorno",
  "block.minecraft.crimson_hyphae": "teccor aira",
  "block.minecraft.warped_hyphae": "teccor hwarin",
  "block.minecraft.oak_leaves": "lassi nornovë",
  "block.minecraft.spruce_leaves": "lassi súcevë",
  "block.minecraft.birch_leaves": "lassi hwindevë",
  "block.minecraft.jungle_leaves": "lassi rostaurëo",
  "block.minecraft.acacia_leaves": "lassi nísimaldavë",
  "block.minecraft.dark_oak_leaves": "lassi morinornovë",
  "block.minecraft.sponge": "hwan",
  "block.minecraft.wet_sponge": "nenda hwan",
  "block.minecraft.glass": "cilin",
  "block.minecraft.lapis_ore": "sincë luiniondo",
  "block.minecraft.lapis_block": "ronwa luiniondo",
  "block.minecraft.dispenser": "estatar",
  "block.minecraft.sandstone": "litsëondo",
  "block.minecraft.chiseled_sandstone": "cantaina litsëondo",
  "block.minecraft.cut_sandstone": "cirina litsëondo",
  "block.minecraft.note_block": "lincolca",
  "block.minecraft.powered_rail": "turna angatië",
  "block.minecraft.detector_rail": "tir-angatië",
  "block.minecraft.sticky_piston": "híma nirma",
  "block.minecraft.cobweb": "hlínë",
  "block.minecraft.grass": "salquë",
  "block.minecraft.fern": "filquë",
  "block.minecraft.dead_bush": "parca tussa",
  "block.minecraft.seagrass": "salquë ëarwa",
  "block.minecraft.sea_pickle": "tarquolosta eäro",
  "block.minecraft.piston": "nirma",
  "block.minecraft.white_wool": "ninquë tó",
  "block.minecraft.orange_wool": "culuina tó",
  "block.minecraft.magenta_wool": "mangenta tó",
  "block.minecraft.light_blue_wool": "helwa tó",
  "block.minecraft.yellow_wool": "malina tó",
  "block.minecraft.lime_wool": "venya tó",
  "block.minecraft.pink_wool": "fanyacarnë tó",
  "block.minecraft.gray_wool": "sinda tó",
  "block.minecraft.light_gray_wool": "mísë tó",
  "block.minecraft.cyan_wool": "fanyaluinë tó",
  "block.minecraft.purple_wool": "luicarnë tó",
  "block.minecraft.blue_wool": "luinë tó",
  "block.minecraft.brown_wool": "varnë tó",
  "block.minecraft.green_wool": "laica tó",
  "block.minecraft.red_wool": "carnë tó",
  "block.minecraft.black_wool": "morë tó",
  "block.minecraft.dandelion": "aurihen",
  "block.minecraft.poppy": "lórelot",
  "block.minecraft.blue_orchid": "helwalot",
  "block.minecraft.allium": "olmelaiquë",
  "block.minecraft.azure_bluet": "caniquis",
  "block.minecraft.red_tulip": "carnë carmincë",
  "block.minecraft.orange_tulip": "culuina carmincë",
  "block.minecraft.white_tulip": "ninquë carmincë",
  "block.minecraft.pink_tulip": "fanyacarnë carmincë",
  "block.minecraft.oxeye_daisy": "lairemírë",
  "block.minecraft.cornflower": "luilótë",
  "block.minecraft.lily_of_the_valley": "indyellótë",
  "block.minecraft.wither_rose": "wither merillë",
  "block.minecraft.brown_mushroom": "varnitelumbë",
  "block.minecraft.red_mushroom": "carnitelumbë",
  "block.minecraft.crimson_fungus": "carnë hwan",
  "block.minecraft.warped_fungus": "hwinda hwan",
  "block.minecraft.crimson_roots": "carni sulcar",
  "block.minecraft.warped_roots": "hwindë sulcar",
  "block.minecraft.nether_sprouts": "tuimar nethero",
  "block.minecraft.weeping_vines": "nainalë uiler",
  "block.minecraft.twisting_vines": "locuiler",
  "block.minecraft.sugar_cane": "lisseliscë",
  "block.minecraft.kelp": "eäruilë",
  "block.minecraft.bamboo": "aldaliscë",
  "block.minecraft.gold_block": "ronwa malto",
  "block.minecraft.iron_block": "ronwa ango",
  "block.minecraft.oak_slab": "perronwa norno",
  "block.minecraft.spruce_slab": "perronwa súcëo",
  "block.minecraft.birch_slab": "perronwa hwindëo",
  "block.minecraft.jungle_slab": "perronwa toa rostaurëo",
  "block.minecraft.acacia_slab": "perronwa nísimaldo",
  "block.minecraft.dark_oak_slab": "perronwa morinorno",
  "block.minecraft.crimson_slab": "perronwa carnituo",
  "block.minecraft.warped_slab": "hwinda perronwa",
  "block.minecraft.stone_slab": "perronwa ondo",
  "block.minecraft.smooth_stone_slab": "perronwa pasta ondo",
  "block.minecraft.sandstone_slab": "perronwa litsëondo",
  "block.minecraft.cut_sandstone_slab": "perronwa cirina litsëondo",
  "block.minecraft.petrified_oak_slab": "sarda perronwa norno",
  "block.minecraft.cobblestone_slab": "perronwa racondo",
  "block.minecraft.brick_slab": "perronwa tesarion",
  "block.minecraft.stone_brick_slab": "perronwa ondotesarion",
  "block.minecraft.nether_brick_slab": "perronwa tesarion nethero",
  "block.minecraft.quartz_slab": "perronwa silmo",
  "block.minecraft.red_sandstone_slab": "perronwa carnë litsëondo",
  "block.minecraft.cut_red_sandstone_slab": "perronwa cirina carnë litsëondo",
  "block.minecraft.purpur_slab": "perronwa purpuro",
  "block.minecraft.prismarine_slab": "perronwa prissimarino",
  "block.minecraft.prismarine_brick_slab": "perronwa tesarion prissimarino",
  "block.minecraft.dark_prismarine_slab": "perronwa morë prissimarino",
  "block.minecraft.smooth_quartz": "ronwa pasta silmo",
  "block.minecraft.smooth_red_sandstone": "pasta carnë litsëondo",
  "block.minecraft.smooth_sandstone": "pasta litsëondo",
  "block.minecraft.smooth_stone": "pasta ondo",
  "block.minecraft.bricks": "tesari",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "parmasarno",
  "block.minecraft.mossy_cobblestone": "lómava racondo",
  "block.minecraft.obsidian": "morë hyellë",
  "block.minecraft.torch": "narrundo",
  "block.minecraft.end_rod": "pirin endo",
  "block.minecraft.chorus_plant": "chorus plant",
  "block.minecraft.chorus_flower": "chorus flower",
  "block.minecraft.purpur_block": "ronwa purpuro",
  "block.minecraft.purpur_pillar": "tarma purpuro",
  "block.minecraft.purpur_stairs": "tyeller purpuro",
  "block.minecraft.spawner": "etyalma",
  "block.minecraft.oak_stairs": "tyeller norno",
  "block.minecraft.chest": "taucolca",
  "block.minecraft.diamond_ore": "sincë tinwírëo",
  "block.minecraft.diamond_block": "ronwa tinwírëo",
  "block.minecraft.crafting_table": "paluhta tamiëo",
  "block.minecraft.farmland": "resta",
  "block.minecraft.furnace": "urna",
  "block.minecraft.ladder": "tyellesta",
  "block.minecraft.rail": "angatië",
  "block.minecraft.cobblestone_stairs": "tyeller racondo",
  "block.minecraft.lever": "ramma",
  "block.minecraft.stone_pressure_plate": "sangapalma ondo",
  "block.minecraft.oak_pressure_plate": "sangapalma norno",
  "block.minecraft.spruce_pressure_plate": "sangapalma súcëo",
  "block.minecraft.birch_pressure_plate": "sangapalma hwindëo",
  "block.minecraft.jungle_pressure_plate": "sangapalma toa rostaurëo",
  "block.minecraft.acacia_pressure_plate": "sangapalma nísimaldo",
  "block.minecraft.dark_oak_pressure_plate": "sangapalma morinorno",
  "block.minecraft.crimson_pressure_plate": "carnitoina sangapalma",
  "block.minecraft.warped_pressure_plate": "hwinda sangapalma",
  "block.minecraft.polished_blackstone_pressure_plate": "sangapalma runda moriondo",
  "block.minecraft.redstone_ore": "sincë redstonëo",
  "block.minecraft.redstone_torch": "narrundo redstonëo",
  "block.minecraft.snow": "lossë",
  "block.minecraft.ice": "helcë",
  "block.minecraft.snow_block": "ronwa lossëo",
  "block.minecraft.cactus": "eccalda",
  "block.minecraft.clay": "luxo",
  "block.minecraft.jukebox": "colca lindalëo",
  "block.minecraft.oak_fence": "hahta norno",
  "block.minecraft.spruce_fence": "hahta súcëo",
  "block.minecraft.birch_fence": "hahta hwindëo",
  "block.minecraft.jungle_fence": "hahta toa rostaurëo",
  "block.minecraft.acacia_fence": "hahta nísimaldo",
  "block.minecraft.dark_oak_fence": "hahta morinorno",
  "block.minecraft.crimson_fence": "carnitoina hahta",
  "block.minecraft.warped_fence": "hwinda hahta",
  "block.minecraft.pumpkin": "culvelyávë",
  "block.minecraft.carved_pumpkin": "cirina culvelyávë",
  "block.minecraft.netherrack": "nether-ondo",
  "block.minecraft.soul_sand": "fëalitsë",
  "block.minecraft.soul_soil": "fëacemen",
  "block.minecraft.basalt": "tornondo",
  "block.minecraft.polished_basalt": "runda tornondo",
  "block.minecraft.soul_torch": "narrundo fëaron",
  "block.minecraft.glowstone": "calondo",
  "block.minecraft.jack_o_lantern": "alta olva",
  "block.minecraft.oak_trapdoor": "lat norno",
  "block.minecraft.spruce_trapdoor": "lat súcëo",
  "block.minecraft.birch_trapdoor": "lat hwindëo",
  "block.minecraft.jungle_trapdoor": "lat toa rostaurëo",
  "block.minecraft.acacia_trapdoor": "lat nísimaldo",
  "block.minecraft.dark_oak_trapdoor": "lat morinorno",
  "block.minecraft.crimson_trapdoor": "carnitoina lat",
  "block.minecraft.warped_trapdoor": "hwinda lat",
  "block.minecraft.infested_stone": "vembëa ondo",
  "block.minecraft.infested_cobblestone": "vembëa racondo",
  "block.minecraft.infested_stone_bricks": "vembië ondotesari",
  "block.minecraft.infested_mossy_stone_bricks": "vembië lómavë ondotesari",
  "block.minecraft.infested_cracked_stone_bricks": "vembië hastainë ondotesari",
  "block.minecraft.infested_chiseled_stone_bricks": "vembië cantainë ondotesari",
  "block.minecraft.stone_bricks": "ondotesari",
  "block.minecraft.mossy_stone_bricks": "lómavë ondotesari",
  "block.minecraft.cracked_stone_bricks": "hastainë ondotesari",
  "block.minecraft.chiseled_stone_bricks": "cantainë ondotesari",
  "block.minecraft.brown_mushroom_block": "ronwa varnitelumbëo",
  "block.minecraft.red_mushroom_block": "ronwa carnitelumbëo",
  "block.minecraft.mushroom_stem": "telco telumbëo",
  "block.minecraft.iron_bars": "angainë sami",
  "block.minecraft.chain": "limil",
  "block.minecraft.glass_pane": "calca",
  "block.minecraft.melon": "laivelyávë",
  "block.minecraft.vine": "uiler",
  "block.minecraft.oak_fence_gate": "ando norno",
  "block.minecraft.spruce_fence_gate": "ando súcëo",
  "block.minecraft.birch_fence_gate": "ando hwindëo",
  "block.minecraft.jungle_fence_gate": "ando toa rostaurëo",
  "block.minecraft.acacia_fence_gate": "ando nísimaldo",
  "block.minecraft.dark_oak_fence_gate": "ando morinorno",
  "block.minecraft.crimson_fence_gate": "ando carnitoina",
  "block.minecraft.warped_fence_gate": "hwinda ando",
  "block.minecraft.brick_stairs": "tyeller tesarion",
  "block.minecraft.stone_brick_stairs": "tyeller ondotesarion",
  "block.minecraft.mycelium": "hwan",
  "block.minecraft.lily_pad": "indil",
  "block.minecraft.nether_bricks": "tesari nethero",
  "block.minecraft.cracked_nether_bricks": "hastainë tesari nethero",
  "block.minecraft.chiseled_nether_bricks": "cantainë tesari nethero",
  "block.minecraft.nether_brick_fence": "hahta tesarion nethero",
  "block.minecraft.nether_brick_stairs": "tyeller tesarion nethero",
  "block.minecraft.enchanting_table": "paluhta luhtiëo",
  "block.minecraft.end_portal_frame": "canta end fendassëo",
  "block.minecraft.end_stone": "ondo endo",
  "block.minecraft.end_stone_bricks": "tesari ondo endo",
  "block.minecraft.dragon_egg": "ohtë hlóceva",
  "block.minecraft.redstone_lamp": "calma redstonëo",
  "block.minecraft.sandstone_stairs": "tyeller litsëondo",
  "block.minecraft.emerald_ore": "sincë laicarilo",
  "block.minecraft.ender_chest": "taucolca endeva",
  "block.minecraft.tripwire_hook": "remmampa",
  "block.minecraft.emerald_block": "ronwa laicarilo",
  "block.minecraft.spruce_stairs": "tyeller súcëo",
  "block.minecraft.birch_stairs": "tyeller hwindëo",
  "block.minecraft.jungle_stairs": "tyeller toa rostaurëo",
  "block.minecraft.crimson_stairs": "carnitoinë tyeller",
  "block.minecraft.warped_stairs": "hwindë tyeller",
  "block.minecraft.command_block": "ronwa axanion",
  "block.minecraft.beacon": "naltama",
  "block.minecraft.cobblestone_wall": "ramba racondo",
  "block.minecraft.mossy_cobblestone_wall": "lómava ramba racondo",
  "block.minecraft.brick_wall": "ramba tesarion",
  "block.minecraft.prismarine_wall": "ramba prissimarino",
  "block.minecraft.red_sandstone_wall": "ramba carnë litsëondo",
  "block.minecraft.mossy_stone_brick_wall": "lómava ramba ondotesarion",
  "block.minecraft.granite_wall": "ramba erdëondo",
  "block.minecraft.stone_brick_wall": "ramba ondotesarion",
  "block.minecraft.nether_brick_wall": "ramba tesarion nethero",
  "block.minecraft.andesite_wall": "ramb' andëondo",
  "block.minecraft.red_nether_brick_wall": "ramba carni tesarion nethero",
  "block.minecraft.sandstone_wall": "ramba litsëondo",
  "block.minecraft.end_stone_brick_wall": "ramba tesarion ondo endo",
  "block.minecraft.diorite_wall": "ramba pelondo",
  "block.minecraft.blackstone_wall": "ramba moriondo",
  "block.minecraft.polished_blackstone_wall": "ramba runda moriondo",
  "block.minecraft.polished_blackstone_brick_wall": "ramba tesarion runda moriondo",
  "block.minecraft.stone_button": "tolma ondo",
  "block.minecraft.oak_button": "tolma norno",
  "block.minecraft.spruce_button": "tolma súcëo",
  "block.minecraft.birch_button": "tolma hwindëo",
  "block.minecraft.jungle_button": "tolma toa rostaurëo",
  "block.minecraft.acacia_button": "tolma nísimaldo",
  "block.minecraft.dark_oak_button": "tolma morinorno",
  "block.minecraft.crimson_button": "carnitoina tolma",
  "block.minecraft.warped_button": "hwinda tolma",
  "block.minecraft.polished_blackstone_button": "tolma runda moriondo",
  "block.minecraft.anvil": "onin",
  "block.minecraft.chipped_anvil": "nicë rácina onin",
  "block.minecraft.damaged_anvil": "rácina onin",
  "block.minecraft.trapped_chest": "cuptaila taucolca",
  "block.minecraft.light_weighted_pressure_plate": "sangapalma malto",
  "block.minecraft.heavy_weighted_pressure_plate": "sangapalma ango",
  "block.minecraft.daylight_detector": "anartirma",
  "block.minecraft.redstone_block": "ronwa redstonëo",
  "block.minecraft.nether_quartz_ore": "sincë silmo",
  "block.minecraft.hopper": "hopper",
  "block.minecraft.chiseled_quartz_block": "cantaina ronwa silmo",
  "block.minecraft.quartz_block": "ronwa silmo",
  "block.minecraft.quartz_bricks": "tesari silmo",
  "block.minecraft.quartz_pillar": "tarma silmo",
  "block.minecraft.quartz_stairs": "tyeller silmo",
  "block.minecraft.activator_rail": "caraitit' angatië",
  "block.minecraft.dropper": "tultar",
  "block.minecraft.white_terracotta": "ninquë cemmastanwa",
  "block.minecraft.orange_terracotta": "culuina cemmastanwa",
  "block.minecraft.magenta_terracotta": "mangenta cemmastanwa",
  "block.minecraft.light_blue_terracotta": "helwa cemmastanwa",
  "block.minecraft.yellow_terracotta": "malina cemmastanwa",
  "block.minecraft.lime_terracotta": "venya cemmastanwa",
  "block.minecraft.pink_terracotta": "fanyacarnë cemmastanwa",
  "block.minecraft.gray_terracotta": "sinda cemmastanwa",
  "block.minecraft.light_gray_terracotta": "mísë cemmastanwa",
  "block.minecraft.cyan_terracotta": "fanyaluinë cemmastanwa",
  "block.minecraft.purple_terracotta": "luicarnë cemmastanwa",
  "block.minecraft.blue_terracotta": "luinë cemmastanwa",
  "block.minecraft.brown_terracotta": "varnë cemmastanwa",
  "block.minecraft.green_terracotta": "laica cemmastanwa",
  "block.minecraft.red_terracotta": "carnë cemmastanwa",
  "block.minecraft.black_terracotta": "morë cemmastanwa",
  "block.minecraft.barrier": "alacénima ramba",
  "block.minecraft.iron_trapdoor": "lat ango",
  "block.minecraft.hay_block": "parca salquë sanga",
  "block.minecraft.white_carpet": "ninquë farma",
  "block.minecraft.orange_carpet": "culuina farma",
  "block.minecraft.magenta_carpet": "mangenta farma",
  "block.minecraft.light_blue_carpet": "helwa farma",
  "block.minecraft.yellow_carpet": "malina farma",
  "block.minecraft.lime_carpet": "venya farma",
  "block.minecraft.pink_carpet": "fanyacarnë farma",
  "block.minecraft.gray_carpet": "sinda farma",
  "block.minecraft.light_gray_carpet": "mísë farma",
  "block.minecraft.cyan_carpet": "fanyaluinë farma",
  "block.minecraft.purple_carpet": "luicarnë farma",
  "block.minecraft.blue_carpet": "luinë farma",
  "block.minecraft.brown_carpet": "varnë farma",
  "block.minecraft.green_carpet": "laica farma",
  "block.minecraft.red_carpet": "carnë farma",
  "block.minecraft.black_carpet": "morë farma",
  "block.minecraft.terracotta": "cemmastanwa",
  "block.minecraft.coal_block": "ronwa hyulmo",
  "block.minecraft.packed_ice": "sanga helce",
  "block.minecraft.acacia_stairs": "tyeller nísimaldo",
  "block.minecraft.dark_oak_stairs": "tyeller morinorno",
  "block.minecraft.slime_block": "ronwa maxo",
  "block.minecraft.grass_path": "tië salquessë",
  "block.minecraft.sunflower": "anarilótë",
  "block.minecraft.lilac": "lilat",
  "block.minecraft.rose_bush": "tussa merillion",
  "block.minecraft.peony": "pëoni",
  "block.minecraft.tall_grass": "halla salquë",
  "block.minecraft.large_fern": "hoa filquë",
  "block.minecraft.white_stained_glass": "ninquë cilin",
  "block.minecraft.orange_stained_glass": "culuina cilin",
  "block.minecraft.magenta_stained_glass": "mangenta cilin",
  "block.minecraft.light_blue_stained_glass": "helwa cilin",
  "block.minecraft.yellow_stained_glass": "malina cilin",
  "block.minecraft.lime_stained_glass": "venya cilin",
  "block.minecraft.pink_stained_glass": "fanyacarnë cilin",
  "block.minecraft.gray_stained_glass": "sinda cilin",
  "block.minecraft.light_gray_stained_glass": "mísë cilin",
  "block.minecraft.cyan_stained_glass": "fanyaluinë cilin",
  "block.minecraft.purple_stained_glass": "luicarnë cilin",
  "block.minecraft.blue_stained_glass": "luinë cilin",
  "block.minecraft.brown_stained_glass": "varnë cilin",
  "block.minecraft.green_stained_glass": "laica cilin",
  "block.minecraft.red_stained_glass": "carnë cilin",
  "block.minecraft.black_stained_glass": "morë cilin",
  "block.minecraft.white_stained_glass_pane": "ninquë calca",
  "block.minecraft.orange_stained_glass_pane": "culuina calca",
  "block.minecraft.magenta_stained_glass_pane": "mangenta calca",
  "block.minecraft.light_blue_stained_glass_pane": "helwa calca",
  "block.minecraft.yellow_stained_glass_pane": "malina calca",
  "block.minecraft.lime_stained_glass_pane": "venya calca",
  "block.minecraft.pink_stained_glass_pane": "fanyacarnë calca",
  "block.minecraft.gray_stained_glass_pane": "sinda calca",
  "block.minecraft.light_gray_stained_glass_pane": "mísë calca",
  "block.minecraft.cyan_stained_glass_pane": "fanyaluinë calca",
  "block.minecraft.purple_stained_glass_pane": "luicarnë calca",
  "block.minecraft.blue_stained_glass_pane": "luinë calca",
  "block.minecraft.brown_stained_glass_pane": "varnë calca",
  "block.minecraft.green_stained_glass_pane": "laica calca",
  "block.minecraft.red_stained_glass_pane": "carnë calca",
  "block.minecraft.black_stained_glass_pane": "morë calca",
  "block.minecraft.prismarine": "prissimarin",
  "block.minecraft.prismarine_bricks": "tesari prissimarino",
  "block.minecraft.dark_prismarine": "morë prissimarin",
  "block.minecraft.prismarine_stairs": "tyeller prissimarino",
  "block.minecraft.prismarine_brick_stairs": "tyeller tesarion prissimarino",
  "block.minecraft.dark_prismarine_stairs": "tyeller morë prissimarino",
  "block.minecraft.sea_lantern": "calma ëarwa",
  "block.minecraft.red_sandstone": "carnë litsëondo",
  "block.minecraft.chiseled_red_sandstone": "cantaina carnë litsëondo",
  "block.minecraft.cut_red_sandstone": "cirina carnë litsëondo",
  "block.minecraft.red_sandstone_stairs": "tyeller carnë litsëondo",
  "block.minecraft.repeating_command_block": "encarila ronwa axanion",
  "block.minecraft.chain_command_block": "limilëa ronwa axanion",
  "block.minecraft.magma_block": "magma block",
  "block.minecraft.nether_wart_block": "ronwa sirpion nethero",
  "block.minecraft.warped_wart_block": "ronwa hwindë sirpion",
  "block.minecraft.red_nether_bricks": "carni tesari nethero",
  "block.minecraft.bone_block": "ronwa axoron",
  "block.minecraft.structure_void": "structure void",
  "block.minecraft.observer": "tirronwa",
  "block.minecraft.shulker_box": "colca hyulcero",
  "block.minecraft.white_shulker_box": "ninquë colca hyulcero",
  "block.minecraft.orange_shulker_box": "culuina colca hyulcero",
  "block.minecraft.magenta_shulker_box": "mangenta colca hyulcero",
  "block.minecraft.light_blue_shulker_box": "helwa colca hyulcero",
  "block.minecraft.yellow_shulker_box": "malina colca hyulcero",
  "block.minecraft.lime_shulker_box": "venya colca hyulcero",
  "block.minecraft.pink_shulker_box": "fanyacarnë colca hyulcero",
  "block.minecraft.gray_shulker_box": "sinda colca hyulcero",
  "block.minecraft.light_gray_shulker_box": "mísë colca hyulcero",
  "block.minecraft.cyan_shulker_box": "fanyaluinë colca hyulcero",
  "block.minecraft.purple_shulker_box": "luicarnë colca hyulcero",
  "block.minecraft.blue_shulker_box": "luinë colca hyulcero",
  "block.minecraft.brown_shulker_box": "varnë colca hyulcero",
  "block.minecraft.green_shulker_box": "laica colca hyulcero",
  "block.minecraft.red_shulker_box": "carnë colca hyulcero",
  "block.minecraft.black_shulker_box": "morë colca hyulcero",
  "block.minecraft.white_glazed_terracotta": "ninquë cilintaina cemmastanwa",
  "block.minecraft.orange_glazed_terracotta": "culuina cilintaina cemmastanwa",
  "block.minecraft.magenta_glazed_terracotta": "mangenta cilintaina cemmastanwa",
  "block.minecraft.light_blue_glazed_terracotta": "helwa cilintaina cemmastanwa",
  "block.minecraft.yellow_glazed_terracotta": "malina cilintaina cemmastanwa",
  "block.minecraft.lime_glazed_terracotta": "venya cilintaina cemmastanwa",
  "block.minecraft.pink_glazed_terracotta": "fanyacarnë cilintaina cemmastanwa",
  "block.minecraft.gray_glazed_terracotta": "sinda cilintaina cemmastanwa",
  "block.minecraft.light_gray_glazed_terracotta": "mísë cilintaina cemmastanwa",
  "block.minecraft.cyan_glazed_terracotta": "fanyaluinë cilintaina cemmastanwa",
  "block.minecraft.purple_glazed_terracotta": "luicarnë cilintaina cemmastanwa",
  "block.minecraft.blue_glazed_terracotta": "luinë cilintaina cemmastanwa",
  "block.minecraft.brown_glazed_terracotta": "varnë cilintaina cemmastanwa",
  "block.minecraft.green_glazed_terracotta": "laica cilintaina cemmastanwa",
  "block.minecraft.red_glazed_terracotta": "carnë cilintaina cemmastanwa",
  "block.minecraft.black_glazed_terracotta": "morë cilintaina cemmastanwa",
  "block.minecraft.white_concrete": "ninquë cemerronda",
  "block.minecraft.orange_concrete": "culuina cemerronda",
  "block.minecraft.magenta_concrete": "mangenta cemerronda",
  "block.minecraft.light_blue_concrete": "helwa cemerronda",
  "block.minecraft.yellow_concrete": "malina cemerronda",
  "block.minecraft.lime_concrete": "venya cemerronda",
  "block.minecraft.pink_concrete": "fanyacarnë cemerronda",
  "block.minecraft.gray_concrete": "sinda cemerronda",
  "block.minecraft.light_gray_concrete": "mísë cemerronda",
  "block.minecraft.cyan_concrete": "fanyaluinë cemerronda",
  "block.minecraft.purple_concrete": "luicarnë cemerronda",
  "block.minecraft.blue_concrete": "luinë cemerronda",
  "block.minecraft.brown_concrete": "varnë cemerronda",
  "block.minecraft.green_concrete": "laica cemerronda",
  "block.minecraft.red_concrete": "carnë cemerronda",
  "block.minecraft.black_concrete": "morë cemerronda",
  "block.minecraft.white_concrete_powder": "ninquë mulo cemerrondo",
  "block.minecraft.orange_concrete_powder": "culuina mulo cemerrondo",
  "block.minecraft.magenta_concrete_powder": "mangenta mulo cemerrondo",
  "block.minecraft.light_blue_concrete_powder": "helwa mulo cemerrondo",
  "block.minecraft.yellow_concrete_powder": "malina mulo cemerrondo",
  "block.minecraft.lime_concrete_powder": "venya mulo cemerrondo",
  "block.minecraft.pink_concrete_powder": "fanyacarnë mulo cemerrondo",
  "block.minecraft.gray_concrete_powder": "sinda mulo cemerrondo",
  "block.minecraft.light_gray_concrete_powder": "mísë mulo cemerrondo",
  "block.minecraft.cyan_concrete_powder": "fanyaluinë mulo cemerrondo",
  "block.minecraft.purple_concrete_powder": "luicarnë mulo cemerrondo",
  "block.minecraft.blue_concrete_powder": "luinë mulo cemerrondo",
  "block.minecraft.brown_concrete_powder": "varnë mulo cemerrondo",
  "block.minecraft.green_concrete_powder": "laica mulo cemerrondo",
  "block.minecraft.red_concrete_powder": "carnë mulo cemerrondo",
  "block.minecraft.black_concrete_powder": "morë mulo cemerrondo",
  "block.minecraft.turtle_egg": "ohtë sandanasto",
  "block.minecraft.dead_tube_coral_block": "dead tube coral block",
  "block.minecraft.dead_brain_coral_block": "dead brain coral block",
  "block.minecraft.dead_bubble_coral_block": "dead bubble coral block",
  "block.minecraft.dead_fire_coral_block": "dead fire coral block",
  "block.minecraft.dead_horn_coral_block": "dead horn coral block",
  "block.minecraft.tube_coral_block": "tube coral block",
  "block.minecraft.brain_coral_block": "brain coral block",
  "block.minecraft.bubble_coral_block": "bubble coral block",
  "block.minecraft.fire_coral_block": "fire coral block",
  "block.minecraft.horn_coral_block": "horn coral block",
  "block.minecraft.tube_coral": "tube coral",
  "block.minecraft.brain_coral": "brain coral",
  "block.minecraft.bubble_coral": "bubble coral",
  "block.minecraft.fire_coral": "fire coral",
  "block.minecraft.horn_coral": "horn coral",
  "block.minecraft.dead_brain_coral": "dead brain coral",
  "block.minecraft.dead_bubble_coral": "dead bubble coral",
  "block.minecraft.dead_fire_coral": "dead fire coral",
  "block.minecraft.dead_horn_coral": "dead horn coral",
  "block.minecraft.dead_tube_coral": "dead tube coral",
  "block.minecraft.tube_coral_fan": "tube coral fan",
  "block.minecraft.brain_coral_fan": "brain coral fan",
  "block.minecraft.bubble_coral_fan": "bubble coral fan",
  "block.minecraft.fire_coral_fan": "fire coral fan",
  "block.minecraft.horn_coral_fan": "horn coral fan",
  "block.minecraft.dead_tube_coral_fan": "dead tube coral fan",
  "block.minecraft.dead_brain_coral_fan": "dead brain coral fan",
  "block.minecraft.dead_bubble_coral_fan": "dead bubble coral fan",
  "block.minecraft.dead_fire_coral_fan": "dead fire coral fan",
  "block.minecraft.dead_horn_coral_fan": "dead horn coral fan",
  "block.minecraft.blue_ice": "luinë helcë",
  "block.minecraft.conduit": "conduit",
  "block.minecraft.polished_granite_stairs": "tyeller runda erdëondo",
  "block.minecraft.smooth_red_sandstone_stairs": "tyeller pasta carnë litsëondo",
  "block.minecraft.mossy_stone_brick_stairs": "lómavë tyeller ondotesarion",
  "block.minecraft.polished_diorite_stairs": "tyeller runda pelondo",
  "block.minecraft.mossy_cobblestone_stairs": "lómavë tyeller racondo",
  "block.minecraft.end_stone_brick_stairs": "tyeller tesarion ondo endo",
  "block.minecraft.stone_stairs": "tyeller ondo",
  "block.minecraft.smooth_sandstone_stairs": "tyeller pasta litsëondo",
  "block.minecraft.smooth_quartz_stairs": "tyeller pasta silmo",
  "block.minecraft.granite_stairs": "tyeller erdëondo",
  "block.minecraft.andesite_stairs": "tyeller andëondo",
  "block.minecraft.red_nether_brick_stairs": "tyeller carni tesarion nethero",
  "block.minecraft.polished_andesite_stairs": "tyeller rund' andëondo",
  "block.minecraft.diorite_stairs": "tyeller pelondo",
  "block.minecraft.polished_granite_slab": "perronwa runda erdëondo",
  "block.minecraft.smooth_red_sandstone_slab": "perronwa pasta carnë litsëondo",
  "block.minecraft.mossy_stone_brick_slab": "lómava perronwa ondotesarion",
  "block.minecraft.polished_diorite_slab": "perronwa runda pelondo",
  "block.minecraft.mossy_cobblestone_slab": "perronwa lómava racondo",
  "block.minecraft.end_stone_brick_slab": "perronwa tesarion ondo endo",
  "block.minecraft.smooth_sandstone_slab": "perronwa pasta litsëondo",
  "block.minecraft.smooth_quartz_slab": "perronwa pasta silmo",
  "block.minecraft.granite_slab": "perronwa erdëondo",
  "block.minecraft.andesite_slab": "perronw' andëondo",
  "block.minecraft.red_nether_brick_slab": "perronwa carni tesarion nethero",
  "block.minecraft.polished_andesite_slab": "perronwa rund' andëondo",
  "block.minecraft.diorite_slab": "perronwa pelondo",
  "block.minecraft.scaffolding": "scaffolding",
  "block.minecraft.iron_door": "fendë ango",
  "block.minecraft.oak_door": "fendë norno",
  "block.minecraft.spruce_door": "fendë súcëo",
  "block.minecraft.birch_door": "fendë hwindëo",
  "block.minecraft.jungle_door": "fendë toa rostaurëo",
  "block.minecraft.acacia_door": "fendë nísimaldo",
  "block.minecraft.dark_oak_door": "fendë morinorno",
  "block.minecraft.crimson_door": "carnitoina fendë",
  "block.minecraft.warped_door": "hwinda fendë",
  "block.minecraft.repeater": "encarilma redstonëo",
  "block.minecraft.comparator": "redstone comparma",
  "block.minecraft.structure_block": "ronwa carmion",
  "block.minecraft.jigsaw": "jigsaw block",
  "item.minecraft.turtle_helmet": "hyalma sandanasto□□caressë:□+2 varma",
  "item.minecraft.scute": "scute",
  "item.minecraft.iron_shovel": "samp' ango□□when in main hand:□+3.5 mahtië hastalë□-3 attack speed",
  "item.minecraft.iron_pickaxe": "ondopelet ango□□when in main hand:□+3 mahtië hastalë□-2.8 attack speed",
  "item.minecraft.iron_axe": "pelecco ango□□when in main hand:□+8 mahtië hastalë□-3.1 attack speed",
  "item.minecraft.flint_and_steel": "nartar",
  "item.minecraft.apple": "orva",
  "item.minecraft.bow": "quinga",
  "item.minecraft.arrow": "pilin",
  "item.minecraft.coal": "hyulma",
  "item.minecraft.charcoal": "hyulma tuo",
  "item.minecraft.diamond": "tinwírë",
  "item.minecraft.iron_ingot": "niht' ango",
  "item.minecraft.gold_ingot": "nihta malto",
  "item.minecraft.netherite_ingot": "nihta neserito",
  "item.minecraft.netherite_scrap": "nihtar neserito",
  "item.minecraft.iron_sword": "macil ango□□when in main hand:□+5 mahtië hastalë□-2.4 attack speed",
  "item.minecraft.wooden_sword": "toina macil□□when in main hand:□+3 mahtië hastalë□-2.4 attack speed",
  "item.minecraft.wooden_shovel": "toina sampa□□when in main hand:□+1.5 mahtië hastalë□-3 attack speed",
  "item.minecraft.wooden_pickaxe": "toina ondopelet□□when in main hand:□+1 mahtië hastalë□-2.8 attack speed",
  "item.minecraft.wooden_axe": "toina pelecco□□when in main hand:□+6 mahtië hastalë□-3.2 attack speed",
  "item.minecraft.stone_sword": "macil ondo□□when in main hand:□+4 mahtië hastalë□-2.4 attack speed",
  "item.minecraft.stone_shovel": "samp' ondo□□when in main hand:□+2.5 mahtië hastalë□-3 attack speed",
  "item.minecraft.stone_pickaxe": "ondopelet ondo□□when in main hand:□+2 mahtië hastalë□-2.8 attack speed",
  "item.minecraft.stone_axe": "pelecc' ondo□□when in main hand:□+8 mahtië hastalë□-3.2 attack speed",
  "item.minecraft.diamond_sword": "macil tinwírëo□□when in main hand:□+6 mahtië hastalë□-2.4 attack speed",
  "item.minecraft.diamond_shovel": "sampa tinwírëo□□when in main hand:□+4.5 mahtië hastalë□-3 attack speed",
  "item.minecraft.diamond_pickaxe": "ondopelet tinwírëo□□when in main hand:□+4 mahtië hastalë□-2.8 attack speed",
  "item.minecraft.diamond_axe": "pelecco tinwírëo□□when in main hand:□+8 mahtië hastalë□-3 attack speed",
  "item.minecraft.stick": "olba",
  "item.minecraft.bowl": "tolpo",
  "item.minecraft.mushroom_stew": "sulpa telumbion",
  "item.minecraft.golden_sword": "macil malto□□when in main hand:□+3 mahtië hastalë□-2.4 attack speed",
  "item.minecraft.golden_shovel": "sampa malto□□when in main hand:□+1.5 mahtië hastalë□-3 attack speed",
  "item.minecraft.golden_pickaxe": "ondopelet malto□□when in main hand:□+1 mahtië hastalë□-2.8 attack speed",
  "item.minecraft.golden_axe": "pelecco malto□□when in main hand:□+6 mahtië hastalë□-3 attack speed",
  "item.minecraft.netherite_sword": "macil neserito□□when in main hand:□+7 mahtië hastalë□-2.4 attack speed",
  "item.minecraft.netherite_shovel": "sampa neserito□□when in main hand:□+5.5 mahtië hastalë□-3 attack speed",
  "item.minecraft.netherite_pickaxe": "ondopelet neserito□□when in main hand:□+5 mahtië hastalë□-2.8 attack speed",
  "item.minecraft.netherite_axe": "pelecco neserito□□when in main hand:□+9 mahtië hastalë□-3 attack speed",
  "item.minecraft.string": "lia",
  "item.minecraft.feather": "quessë",
  "item.minecraft.gunpowder": "nárasto",
  "item.minecraft.wooden_hoe": "toina hyarincë□□when in main hand:□-3 attack speed",
  "item.minecraft.stone_hoe": "hyarincë ondo□□when in main hand:□-2 attack speed",
  "item.minecraft.iron_hoe": "hyarincë ango□□when in main hand:□-1 attack speed",
  "item.minecraft.diamond_hoe": "hyarincë tinwírëo□□when in main hand:",
  "item.minecraft.golden_hoe": "hyarincë malto□□when in main hand:□-3 attack speed",
  "item.minecraft.netherite_hoe": "hyarincë neserito□□when in main hand:",
  "item.minecraft.wheat_seeds": "erdi massalquëo",
  "item.minecraft.wheat": "massalquë",
  "item.minecraft.bread": "massa",
  "item.minecraft.leather_helmet": "carpë aluo□□caressë:□+1 varma",
  "item.minecraft.leather_chestplate": "laupë aluo□□when on body:□+3 varma",
  "item.minecraft.leather_leggings": "telcoham aluo□□when on legs:□+2 varma",
  "item.minecraft.leather_boots": "hyapatu aluo□□when on feet:□+1 varma",
  "item.minecraft.chainmail_helmet": "castol angarembëo□□caressë:□+2 varma",
  "item.minecraft.chainmail_chestplate": "amborcaum' angarembëo□□when on body:□+5 varma",
  "item.minecraft.chainmail_leggings": "telcoham angarembëo□□when on legs:□+4 varma",
  "item.minecraft.chainmail_boots": "hyapatu angarembëo□□when on feet:□+1 varma",
  "item.minecraft.iron_helmet": "castol ango□□caressë:□+2 varma",
  "item.minecraft.iron_chestplate": "amborcaum' ango□□when on body:□+6 varma",
  "item.minecraft.iron_leggings": "telcoham ango□□when on legs:□+5 varma",
  "item.minecraft.iron_boots": "hyapatu ango□□when on feet:□+2 varma",
  "item.minecraft.diamond_helmet": "castol tinwírëo□□caressë:□+3 varma□+2 tornië varmo",
  "item.minecraft.diamond_chestplate": "amborcauma tinwírëo□□when on body:□+8 varma□+2 tornië varmo",
  "item.minecraft.diamond_leggings": "telcoham tinwírëo□□when on legs:□+6 varma□+2 tornië varmo",
  "item.minecraft.diamond_boots": "hyapatu tinwírëo□□when on feet:□+3 varma□+2 tornië varmo",
  "item.minecraft.golden_helmet": "castol malto□□caressë:□+2 varma",
  "item.minecraft.golden_chestplate": "amborcauma malto□□when on body:□+5 varma",
  "item.minecraft.golden_leggings": "telcoham malto□□when on legs:□+3 varma",
  "item.minecraft.golden_boots": "hyapatu malto□□when on feet:□+1 varma",
  "item.minecraft.netherite_helmet": "castol neserito□□caressë:□+3 varma□+3 tornië varmo□+1 nampalpaléo nornië",
  "item.minecraft.netherite_chestplate": "amborcauma neserito□□when on body:□+8 varma□+3 tornië varmo□+1 nampalpaléo nornië",
  "item.minecraft.netherite_leggings": "telcoham neserito□□when on legs:□+6 varma□+3 tornië varmo□+1 nampalpaléo nornië",
  "item.minecraft.netherite_boots": "hyapatu neserito□□when on feet:□+3 varma□+3 tornië varmo□+1 nampalpaléo nornië",
  "item.minecraft.flint": "sinca",
  "item.minecraft.porkchop": "hrávë polco",
  "item.minecraft.cooked_porkchop": "apsa polco",
  "item.minecraft.painting": "tecemma",
  "item.minecraft.golden_apple": "orva malto",
  "item.minecraft.enchanted_golden_apple": "luhtaina maltorva",
  "block.minecraft.oak_sign": "tanna norno",
  "block.minecraft.spruce_sign": "tanna súcëo",
  "block.minecraft.birch_sign": "tanna hwindëo",
  "block.minecraft.jungle_sign": "tanna toa rostaurëo",
  "block.minecraft.acacia_sign": "tanna nísimaldo",
  "block.minecraft.dark_oak_sign": "tanna morinorno",
  "block.minecraft.crimson_sign": "carnitoina tanna",
  "block.minecraft.warped_sign": "hwinda tanna",
  "item.minecraft.bucket": "calpa",
  "item.minecraft.water_bucket": "calpa neno",
  "item.minecraft.lava_bucket": "calpa sirëanáro",
  "item.minecraft.minecart": "raxa",
  "item.minecraft.saddle": "hanwa",
  "item.minecraft.redstone": "asto redstonëo",
  "item.minecraft.snowball": "lossecoron",
  "item.minecraft.oak_boat": "luntë norno",
  "item.minecraft.leather": "alu",
  "item.minecraft.milk_bucket": "calpa ilimbo",
  "item.minecraft.pufferfish_bucket": "bucket of pufferfish",
  "item.minecraft.salmon_bucket": "bucket of salmon",
  "item.minecraft.cod_bucket": "bucket of cod",
  "item.minecraft.tropical_fish_bucket": "bucket of tropical fish",
  "item.minecraft.brick": "tesar",
  "item.minecraft.clay_ball": "clay ball",
  "block.minecraft.dried_kelp_block": "ronwa parahtaina ëaruilëo",
  "item.minecraft.paper": "hyalin",
  "item.minecraft.book": "parma",
  "item.minecraft.slime_ball": "mehelecoron",
  "item.minecraft.chest_minecart": "rax' as taucolca",
  "item.minecraft.furnace_minecart": "rax' as urna",
  "item.minecraft.egg": "ohtë",
  "item.minecraft.compass": "mententar",
  "item.minecraft.fishing_rod": "lingwëhimya",
  "item.minecraft.clock": "lúma",
  "item.minecraft.glowstone_dust": "asto calondo",
  "item.minecraft.cod": "raw cod",
  "item.minecraft.salmon": "haltano hrávë",
  "item.minecraft.tropical_fish": "tropical fish",
  "item.minecraft.pufferfish": "lingwë tiuyana",
  "item.minecraft.cooked_cod": "cooked cod",
  "item.minecraft.cooked_salmon": "apsa haltano",
  "item.minecraft.ink_sac": "pocollë as móro",
  "item.minecraft.red_dye": "carnë quilë",
  "item.minecraft.green_dye": "laica quilë",
  "item.minecraft.cocoa_beans": "erdi cacávo",
  "item.minecraft.lapis_lazuli": "luinion",
  "item.minecraft.purple_dye": "luicarnë quilë",
  "item.minecraft.cyan_dye": "fanyaluinë quilë",
  "item.minecraft.light_gray_dye": "mísë quilë",
  "item.minecraft.gray_dye": "sinda quilë",
  "item.minecraft.pink_dye": "fanyacarnë quilë",
  "item.minecraft.lime_dye": "venya quilë",
  "item.minecraft.yellow_dye": "malina quilë",
  "item.minecraft.light_blue_dye": "helwa quilë",
  "item.minecraft.magenta_dye": "mangenta quilë",
  "item.minecraft.orange_dye": "culuina quilë",
  "item.minecraft.bone_meal": "axomulë",
  "item.minecraft.blue_dye": "luinë quilë",
  "item.minecraft.brown_dye": "varnë quilë",
  "item.minecraft.black_dye": "morë quilë",
  "item.minecraft.white_dye": "ninquë quilë",
  "item.minecraft.bone": "axo",
  "item.minecraft.sugar": "lís",
  "block.minecraft.cake": "masta",
  "block.minecraft.white_bed": "ninquë caima",
  "block.minecraft.orange_bed": "culuina caima",
  "block.minecraft.magenta_bed": "mangenta caima",
  "block.minecraft.light_blue_bed": "helwa caima",
  "block.minecraft.yellow_bed": "malina caima",
  "block.minecraft.lime_bed": "venya caima",
  "block.minecraft.pink_bed": "fanyacarnë caima",
  "block.minecraft.gray_bed": "sinda caima",
  "block.minecraft.light_gray_bed": "mísë caima",
  "block.minecraft.cyan_bed": "fanyaluinë caima",
  "block.minecraft.purple_bed": "luicarnë caima",
  "block.minecraft.blue_bed": "luinë caima",
  "block.minecraft.brown_bed": "varnë caima",
  "block.minecraft.green_bed": "laica caima",
  "block.minecraft.red_bed": "carnë caima",
  "block.minecraft.black_bed": "morë caima",
  "item.minecraft.cookie": "mastaincë",
  "item.minecraft.filled_map": "noremma□#0",
  "item.minecraft.shears": "aucirma",
  "item.minecraft.melon_slice": "hócirda laivelyávëo",
  "item.minecraft.dried_kelp": "parahtaina ëaruilë",
  "item.minecraft.pumpkin_seeds": "erdi culvelyávëo",
  "item.minecraft.melon_seeds": "erdi laivelyávëo",
  "item.minecraft.beef": "hrávë yaxëo",
  "item.minecraft.cooked_beef": "apsa yaxëo",
  "item.minecraft.chicken": "hrávë porocëo",
  "item.minecraft.cooked_chicken": "apsa porocëo",
  "item.minecraft.rotten_flesh": "saura hrávë",
  "item.minecraft.ender_pearl": "eässar endo",
  "item.minecraft.blaze_rod": "pirin uryamóva",
  "item.minecraft.ghast_tear": "nië ñasto",
  "item.minecraft.gold_nugget": "nihta malto",
  "item.minecraft.nether_wart": "sirpë nethero",
  "item.minecraft.potion": "latámima yulda□no effects",
  "item.minecraft.glass_bottle": "olpë cilino",
  "item.minecraft.spider_eye": "hen liantëo",
  "item.minecraft.fermented_spider_eye": "púlina hen liantëo",
  "item.minecraft.blaze_powder": "uryamulo",
  "item.minecraft.magma_cream": "coron síranáreva",
  "block.minecraft.brewing_stand": "velma",
  "block.minecraft.cauldron": "tambin",
  "item.minecraft.ender_eye": "hen endo",
  "item.minecraft.glistering_melon_slice": "laurëa hócirda laivelyávëo",
  "item.minecraft.bat_spawn_egg": "ohtë quildareva",
  "item.minecraft.bee_spawn_egg": "ohtë nierwa",
  "item.minecraft.blaze_spawn_egg": "ohtë uryamóva",
  "item.minecraft.cat_spawn_egg": "ohtë miuróva",
  "item.minecraft.cave_spider_spawn_egg": "ohtë felcoliantéva",
  "item.minecraft.chicken_spawn_egg": "ohtë porocéva",
  "item.minecraft.cod_spawn_egg": "cod spawn egg",
  "item.minecraft.cow_spawn_egg": "ohtë yaxeva",
  "item.minecraft.creeper_spawn_egg": "ohtë creeperwa",
  "item.minecraft.dolphin_spawn_egg": "ohtë nostalingweva",
  "item.minecraft.donkey_spawn_egg": "ohtë pellopeva",
  "item.minecraft.drowned_spawn_egg": "ohtë quormova",
  "item.minecraft.elder_guardian_spawn_egg": "ohtë cundo anyárava",
  "item.minecraft.enderman_spawn_egg": "ohtë endermanwa",
  "item.minecraft.endermite_spawn_egg": "endermite spawn egg",
  "item.minecraft.evoker_spawn_egg": "ohtë yalmova",
  "item.minecraft.fox_spawn_egg": "ohtë ruscova",
  "item.minecraft.ghast_spawn_egg": "ohtë ñastova",
  "item.minecraft.guardian_spawn_egg": "ohtë cundóva",
  "item.minecraft.hoglin_spawn_egg": "ohtë hongilinwa",
  "item.minecraft.horse_spawn_egg": "ohtë roccóva",
  "item.minecraft.husk_spawn_egg": "ohtë tarquamova",
  "item.minecraft.llama_spawn_egg": "ohtë lamava",
  "item.minecraft.magma_cube_spawn_egg": "magma cube spawn egg",
  "item.minecraft.mooshroom_spawn_egg": "mooshroom spawn egg",
  "item.minecraft.mule_spawn_egg": "mule spawn egg",
  "item.minecraft.ocelot_spawn_egg": "ocelot spawn egg",
  "item.minecraft.panda_spawn_egg": "ohtë pandava",
  "item.minecraft.parrot_spawn_egg": "ohtë quetaiweva",
  "item.minecraft.phantom_spawn_egg": "ohtë lóreraucova",
  "item.minecraft.pig_spawn_egg": "ohtë polcava",
  "item.minecraft.piglin_spawn_egg": "ohtë pingilinwa",
  "item.minecraft.pillager_spawn_egg": "pillager spawn egg",
  "item.minecraft.polar_bear_spawn_egg": "ohtë morcova",
  "item.minecraft.pufferfish_spawn_egg": "pufferfish spawn egg",
  "item.minecraft.rabbit_spawn_egg": "ohtë lopóva",
  "item.minecraft.ravager_spawn_egg": "ohtë ascantova",
  "item.minecraft.salmon_spawn_egg": "salmon spawn egg",
  "item.minecraft.sheep_spawn_egg": "ohtë mámava",
  "item.minecraft.shulker_spawn_egg": "ohtë hyulcerwa",
  "item.minecraft.silverfish_spawn_egg": "ohtë telpingweva",
  "item.minecraft.skeleton_spawn_egg": "ohtë axoquenwa",
  "item.minecraft.skeleton_horse_spawn_egg": "ohtë návaroccova",
  "item.minecraft.slime_spawn_egg": "ohtë maxomova",
  "item.minecraft.spider_spawn_egg": "ohtë lianteva",
  "item.minecraft.squid_spawn_egg": "ohtë mórolingweva",
  "item.minecraft.stray_spawn_egg": "stray spawn egg",
  "item.minecraft.strider_spawn_egg": "strider spawn egg",
  "item.minecraft.trader_llama_spawn_egg": "trader llama spawn egg",
  "item.minecraft.tropical_fish_spawn_egg": "tropical fish spawn egg",
  "item.minecraft.turtle_spawn_egg": "ohtë sandanastóva",
  "item.minecraft.vex_spawn_egg": "ohtë tarastarwa",
  "item.minecraft.villager_spawn_egg": "ohtë opelemova",
  "item.minecraft.vindicator_spawn_egg": "vindicator spawn egg",
  "item.minecraft.wandering_trader_spawn_egg": "wandering trader spawn egg",
  "item.minecraft.witch_spawn_egg": "ohtë curuniva",
  "item.minecraft.wither_skeleton_spawn_egg": "ohtë wither-axoquenwa",
  "item.minecraft.wolf_spawn_egg": "ohtë rácava",
  "item.minecraft.zoglin_spawn_egg": "ohtë rongilinwa",
  "item.minecraft.zombie_spawn_egg": "ohtë urcóva",
  "item.minecraft.zombie_horse_spawn_egg": "ohtë urcoya roccóva",
  "item.minecraft.zombie_villager_spawn_egg": "ohtë urcoya opelemóva",
  "item.minecraft.zombified_piglin_spawn_egg": "ohtë urcoya pingilinwa",
  "item.minecraft.experience_bottle": "olpë luhtiëo",
  "item.minecraft.fire_charge": "nárë tintacoro",
  "item.minecraft.writable_book": "parma ar tecil",
  "item.minecraft.written_book": "tecina parma",
  "item.minecraft.emerald": "laicaril",
  "item.minecraft.item_frame": "emma venwë",
  "block.minecraft.flower_pot": "tambë",
  "item.minecraft.carrot": "rassulca",
  "item.minecraft.potato": "cemorva",
  "item.minecraft.baked_potato": "mastanwa cemorva",
  "item.minecraft.poisonous_potato": "hloirëa cemorva",
  "item.minecraft.map": "cumna noremma",
  "item.minecraft.golden_carrot": "culsulca",
  "block.minecraft.skeleton_skull": "coropë axoqueno",
  "block.minecraft.wither_skeleton_skull": "coropë wither-axoqueno",
  "block.minecraft.player_head": "cas tyalindo",
  "block.minecraft.zombie_head": "cas urco",
  "block.minecraft.creeper_head": "cas creepero",
  "block.minecraft.dragon_head": "cas hlócëo",
  "item.minecraft.carrot_on_a_stick": "rassulca olbassë",
  "item.minecraft.warped_fungus_on_a_stick": "hwinda hwan olbassë",
  "item.minecraft.nether_star": "elen nethero",
  "item.minecraft.pumpkin_pie": "masta culvelyávëo",
  "item.minecraft.firework_rocket": "nartanwë",
  "item.minecraft.firework_star": "firework star",
  "item.minecraft.enchanted_book": "luhtaina parma",
  "item.minecraft.nether_brick": "tesar nethero",
  "item.minecraft.quartz": "silma nethero",
  "item.minecraft.tnt_minecart": "rax' as tnt",
  "item.minecraft.hopper_minecart": "minecart with hopper",
  "item.minecraft.prismarine_shard": "nihta prissimarino",
  "item.minecraft.prismarine_crystals": "prissimarili",
  "item.minecraft.rabbit": "hrávë lopo",
  "item.minecraft.cooked_rabbit": "apsa lopo",
  "item.minecraft.rabbit_stew": "sulpa lopo",
  "item.minecraft.rabbit_foot": "tál lopo",
  "item.minecraft.rabbit_hide": "helma lopo",
  "item.minecraft.armor_stand": "varma tulco",
  "item.minecraft.iron_horse_armor": "angaina cauma rocco",
  "item.minecraft.golden_horse_armor": "maltaina cauma rocco",
  "item.minecraft.diamond_horse_armor": "tinwírina cauma rocco",
  "item.minecraft.leather_horse_armor": "aluina cauma rocco",
  "item.minecraft.lead": "lelyalímë",
  "item.minecraft.name_tag": "essetanna",
  "item.minecraft.command_block_minecart": "rax' as ronwa axanion",
  "item.minecraft.mutton": "hrávë mámo",
  "item.minecraft.cooked_mutton": "apsa mámo",
  "block.minecraft.white_banner": "ninquë lantanna",
  "block.minecraft.orange_banner": "culuina lantanna",
  "block.minecraft.magenta_banner": "mangenta lantanna",
  "block.minecraft.light_blue_banner": "helwa lantanna",
  "block.minecraft.yellow_banner": "malina lantanna",
  "block.minecraft.lime_banner": "venya lantanna",
  "block.minecraft.pink_banner": "fanyacarnë lantanna",
  "block.minecraft.gray_banner": "sinda lantanna",
  "block.minecraft.light_gray_banner": "mísë lantanna",
  "block.minecraft.cyan_banner": "fanyaluinë lantanna",
  "block.minecraft.purple_banner": "luicarnë lantanna",
  "block.minecraft.blue_banner": "luinë lantanna",
  "block.minecraft.brown_banner": "varnë lantanna",
  "block.minecraft.green_banner": "laica lantanna",
  "block.minecraft.red_banner": "carnë lantanna",
  "block.minecraft.black_banner": "morë lantanna",
  "item.minecraft.end_crystal": "mettamaril",
  "item.minecraft.chorus_fruit": "chorus fruit",
  "item.minecraft.popped_chorus_fruit": "popped chorus fruit",
  "item.minecraft.beetroot": "beetroot",
  "item.minecraft.beetroot_seeds": "beetroot seeds",
  "item.minecraft.beetroot_soup": "beetroot soup",
  "item.minecraft.dragon_breath": "foa hlócëo",
  "item.minecraft.splash_potion": "hátima latámima yulda□no effects",
  "item.minecraft.spectral_arrow": "pilindë ausaleva",
  "item.minecraft.tipped_arrow": "latámima pilin as hloima□no effects",
  "item.minecraft.lingering_potion": "lemyaila latámima yulda□no effects",
  "item.minecraft.shield": "sanda",
  "item.minecraft.elytra": "rámat",
  "item.minecraft.spruce_boat": "luntë súcëo",
  "item.minecraft.birch_boat": "luntë hwindëo",
  "item.minecraft.jungle_boat": "luntë toa rostaurëo",
  "item.minecraft.acacia_boat": "luntë nísimaldo",
  "item.minecraft.dark_oak_boat": "luntë morinorno",
  "item.minecraft.totem_of_undying": "totem of undying",
  "item.minecraft.shulker_shell": "hyalma hyulcero",
  "item.minecraft.iron_nugget": "niht' ango",
  "item.minecraft.knowledge_book": "nóleparma",
  "item.minecraft.debug_stick": "debug stick",
  "item.minecraft.music_disc_13": "rindë lindalëo□c418 - 13",
  "item.minecraft.music_disc_cat": "rindë lindalëo□c418 - cat",
  "item.minecraft.music_disc_blocks": "rindë lindalëo□c418 - blocks",
  "item.minecraft.music_disc_chirp": "rindë lindalëo□c418 - chirp",
  "item.minecraft.music_disc_far": "rindë lindalëo□c418 - far",
  "item.minecraft.music_disc_mall": "rindë lindalëo□c418 - mall",
  "item.minecraft.music_disc_mellohi": "rindë lindalëo□c418 - mellohi",
  "item.minecraft.music_disc_stal": "rindë lindalëo□c418 - stal",
  "item.minecraft.music_disc_strad": "rindë lindalëo□c418 - strad",
  "item.minecraft.music_disc_ward": "rindë lindalëo□c418 - ward",
  "item.minecraft.music_disc_11": "rindë lindalëo□c418 - 11",
  "item.minecraft.music_disc_wait": "rindë lindalëo□c418 - wait",
  "item.minecraft.music_disc_pigstep": "rindë lindalëo□lena raine - pigstep",
  "item.minecraft.trident": "nelcarca□□when in main hand:□+8 mahtië hastalë□-2.9 attack speed",
  "item.minecraft.phantom_membrane": "helma lórerauco",
  "item.minecraft.nautilus_shell": "hyalma nautilo",
  "item.minecraft.heart_of_the_sea": "hon eärwa",
  "item.minecraft.crossbow": "lanquinga",
  "item.minecraft.suspicious_stew": "suspicious stew",
  "block.minecraft.loom": "lanwa",
  "item.minecraft.flower_banner_pattern": "ocantië lantanno□canta almo",
  "item.minecraft.creeper_banner_pattern": "ocantië lantanno□cendelë creeperwa",
  "item.minecraft.skull_banner_pattern": "ocantië lantanno□canta coropëo",
  "item.minecraft.mojang_banner_pattern": "ocantië lantanno□nat",
  "item.minecraft.globe_banner_pattern": "ocantië lantanno□coron",
  "item.minecraft.piglin_banner_pattern": "ocantië lantanno□mundo",
  "block.minecraft.composter": "composter",
  "block.minecraft.barrel": "corcolca",
  "block.minecraft.smoker": "ustyar",
  "block.minecraft.blast_furnace": "ticutaitë urna",
  "block.minecraft.cartography_table": "paluhta noremmaron",
  "block.minecraft.fletching_table": "paluhta pilintano",
  "block.minecraft.grindstone": "runwa",
  "block.minecraft.lectern": "parmatarma",
  "block.minecraft.smithing_table": "paluhta macalëo",
  "block.minecraft.stonecutter": "ondocirma",
  "block.minecraft.bell": "nyellë",
  "block.minecraft.lantern": "calma",
  "block.minecraft.soul_lantern": "calma fëaron",
  "item.minecraft.sweet_berries": "lipsior",
  "block.minecraft.campfire": "ruinë",
  "block.minecraft.soul_campfire": "ruinë fëaron",
  "block.minecraft.shroomlight": "calatelumbë",
  "item.minecraft.honeycomb": "nehtelë",
  "block.minecraft.bee_nest": "hausta nierion",
  "block.minecraft.beehive": "nieresta",
  "item.minecraft.honey_bottle": "olpë as nehtë",
  "block.minecraft.honey_block": "ronwa nehtëo",
  "block.minecraft.honeycomb_block": "ronwa nehtelion",
  "block.minecraft.lodestone": "rantondo",
  "block.minecraft.netherite_block": "ronwa neserito",
  "block.minecraft.ancient_debris": "ancient debris",
  "block.minecraft.target": "mehtë",
  "block.minecraft.crying_obsidian": "crying obsidian",
  "block.minecraft.blackstone": "moriondo",
  "block.minecraft.blackstone_slab": "perronwa moriondo",
  "block.minecraft.blackstone_stairs": "tyeller moriondo",
  "block.minecraft.gilded_blackstone": "gilded blackstone",
  "block.minecraft.polished_blackstone": "runda moriondo",
  "block.minecraft.polished_blackstone_slab": "perronwa runda moriondo",
  "block.minecraft.polished_blackstone_stairs": "tyeller runda moriondo",
  "block.minecraft.chiseled_polished_blackstone": "chiseled polished blackstone",
  "block.minecraft.polished_blackstone_bricks": "tesari runda moriondo",
  "block.minecraft.polished_blackstone_brick_slab": "perronwa tesarion runda moriondo",
  "block.minecraft.polished_blackstone_brick_stairs": "tyeller tesarion runda moriondo",
  "block.minecraft.cracked_polished_blackstone_bricks": "hastainë tesari runda moriondo",
  "block.minecraft.respawn_anchor": "ampa enontiëo",
}
export const qya_aa = items; 
